import { defineStore } from "pinia"
import { useStorage } from "@vueuse/core"

export const useScheduleItemStore = defineStore( "ScheduleItemStore", {

    state: () => {
        return {
            scheduleItems: [],
            workshops: [],
            generalSessions: [],
            locations: [],
            currentFilters: {
                search: '',
                location: '',
                type: '',
                id: '',
                session: '',
                workshop: '',
                bookmark: '',
            },
            filterActive: false,
            showFilters: false,
            dateTimes: {},
            bookmarkedIDs: useStorage( 'bookmarkedIDs', [] ),
            microcopy: {},
            openModal: {
                item: {},
                partOf: '',
                type: ''
            },
            modalState: false,
            view: ''
        }
    },

    actions: {
        fillScheduleItems ( items ) {
            this.scheduleItems.push( ...items )
        },
        fillWorkshops ( workshops ) {
            this.workshops.push( ...workshops )
        },
        fillLocations ( locations ) {
            this.locations.push( ...locations )
        },
        fillGeneralSessions ( sessions ) {
            this.generalSessions.push( ...sessions )
        },
        fillDateTimes( dateTimes ) {
            this.dateTimes = dateTimes
        },
        fillMicroCopy( microcopy ) {
            this.microcopy = microcopy
        },
        setCurrentFilter ( key, value ) {
            this.clearAllFilters()
            this.currentFilters[key] = value
            if ( key === 'search' && value === '' ) {
                this.filterActive = false
            } else {
                this.filterActive = true
            }

            const slesWrapper = document.querySelector('.sles__wrapper')
            if ( slesWrapper ) {
                slesWrapper.scrollTo( { 'top': 0, 'left': 0 } );
            }
        },
        setOpenModal (item, parent, type) {
            this.openModal.item = item
            this.openModal.partOf = parent,
            this.openModal.type = type
        },
        clearFilter ( key ) {
            this.currentFilters[key] = ''
            // Last one? set filterActive on false
            const filterKeys = Object.keys(this.currentFilters)
            let anyActiveFilter = false
            filterKeys.forEach((key) => {
                if ( this.currentFilters[key] !== '' ) {
                    anyActiveFilter = true
                }
            })
            this.filterActive = anyActiveFilter
        },
        clearAllFilters () {
            const filterKeys = Object.keys(this.currentFilters)
            filterKeys.forEach((key) => {
                this.currentFilters[key] = ''
            })
            this.filterActive = false

            const slesWrapper = document.querySelector('.sles__wrapper')
            if ( slesWrapper ) {
                slesWrapper.scrollTo( { 'top': 0, 'left': 0 } );
            }
        },
        addBookmark ( id ) {
            this.bookmarkedIDs.push(id)
        },
        clearBookmarks () {
            this.bookmarkedIDs = []
            this.currentFilters['bookmark'] = ''
        },
        removeBookmark (id) {
            this.bookmarkedIDs.splice(this.bookmarkedIDs.indexOf(id), 1)
            // Last one? clear bookmark filter (reset)
            if ( this.bookmarkedIDs.length < 1 ) {
                this.currentFilters['bookmark'] = ''
            }
        },
        setModalState (modalState) {
            const html = document.querySelector('html');
            if ( modalState ) {
                html.classList.add('prevent-scroll');
                document.body.classList.add('prevent-scroll');
            } else {
                html.classList.remove('prevent-scroll');
                document.body.classList.remove('prevent-scroll');
            }
            this.modalState = modalState
        },
        setView (viewState) {
            this.clearAllFilters()

            document.body.classList.remove('sles--show-compact', 'sles--show-large', 'sles--show-list', 'sles--show-schedule', 'sles--show-favs')
            document.body.classList.add(`sles--show-${viewState}`)
            if (viewState == 'compact' || viewState == 'large') {
               document.body.classList.add('sles--show-schedule');
            } else if (viewState == 'favs') {
                document.body.classList.add('sles--show-list');
            }

            const previousView = this.view
            this.view = viewState

            // console.log( 'dispatch viewSwitched event' )
            const viewSwitched = new CustomEvent( 'viewSwitched', { 'detail': { 'state': this.view, 'previousView': previousView } } )
            document.dispatchEvent( viewSwitched )
        }
    },

    getters: {
        filteredItems: (state) => {
            const filterKeys = Object.keys(state.currentFilters)
            return state.scheduleItems.filter((item) => {
                return filterKeys.every((key) => {
                    if ( state.currentFilters[key].length === 0 ) {
                        return true
                    }
                    else if ( key === 'search' ) {

                        if ( state.currentFilters[key].length > 2 ) {

                            let posterAsResult = false
                            if ( item.item_type === 'poster' ) {
                                // return als een van de poster presentations matcht
                                posterAsResult = item.item_poster_papers_programme.filter( ( poster ) => {
                                    return poster.title.toLowerCase().includes(state.currentFilters[key].toLowerCase()) || poster.item_presenters_full.toLowerCase().includes(state.currentFilters[key].toLowerCase())
                                }).length > 0
                            }
                            return item.title.toLowerCase().includes(state.currentFilters[key].toLowerCase())
                            || item.item_presenters_full.toLowerCase().includes(state.currentFilters[key].toLowerCase())
                            || item.item_paper_title.toLowerCase().includes(state.currentFilters[key].toLowerCase()) || posterAsResult

                        } else {
                            return true
                        }

                    }
                    else if ( key === 'workshop' ) {
                        return item.item_ws_slug === state.currentFilters[key]
                    } 
                    else if ( key === 'session' ) {
                        return item.item_gs_slug === state.currentFilters[key]
                    }
                    else if ( key === 'bookmark' ) {
                        return state.bookmarkedIDs.findIndex( (id) => { return item.id === id } ) !== -1
                    }
                    else {
                        return item[`item_${ key }`] === state.currentFilters[key]
                    }
                })
            })
        },
        continuousSessions: (state) => {
            const workshopID = 486 
            const workshopItems = state.scheduleItems.filter((item) => {
                return item.item_workshop === workshopID
            })
            const breakpoints = [0]
            workshopItems.forEach((item, index) => {
                const scheduleIndex = state.scheduleItems.findIndex((el) => {
                    return el.id === item.id
                })
                if (index > 0) {
                    if (item.dayAsSlug !== workshopItems[index - 1].dayAsSlug || item.item_location !== workshopItems[index - 1].item_location) {
                        breakpoints.push(index)
                    } else if (workshopID !== state.scheduleItems[scheduleIndex - 1].item_workshop) {
                        breakpoints.push(index)
                    }
                }
            })
            return breakpoints
        },
        getLocations: (state) => {
            return state.locations
        },
        getNumberOfTotalItems: (state) => {
            return state.scheduleItems.length
        },
        getDateTimes: (state) => {
            return state.dateTimes
        },
        getAllItems: (state) => {
            return state.scheduleItems
        }
    }

} )